import { httpClient } from '@connectors/HttpClient'

import { type EmailMessage } from '../types'

export const EmailMessageService = {
    checkEmailQueue: async (): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/email-messages/check-email-queue`)
        return response.data
    },
    list: async ({
        offset,
        limit,
        sortBy = 'createdAt',
        sortOrder = 'desc'
    }: {
        offset: number
        limit: number
        sortBy?: string
        sortOrder?: string
    }): Promise<{
        totalCount: number
        emails: EmailMessage[]
    }> => {
        const response = await httpClient.axios.get(`/admin/email-messages`, {
            params: {
                offset,
                limit,
                sortBy,
                sortOrder
            }
        })
        return response.data
    },
    send: async (emailMessageId: string): Promise<void> => {
        const response = await httpClient.axios.post(`/admin/email-messages/${emailMessageId}`)
        return response.data
    },
    testQueue: async (): Promise<void> => {
        const response = await httpClient.axios.post(`/admin/email-messages/test-queue`)
        return response.data
    }
}
